export interface State {
    vrm: string;
    checked: boolean;
    extended: boolean;
    notCatCorD: boolean;
    notCatSorN: boolean;
    notImported: boolean;
    originalNumberPlate: boolean;
    originalColour: boolean;
}

export const UPDATE_VHC = 'UPDATE_VHC';
export const updateVhc = (payload?: State) => ({
    type: UPDATE_VHC,
    payload,
});

export default (state = {}, action): State =>
    action.type === UPDATE_VHC ? { ...state, ...action.payload } : state;
